import React from 'react';

import { Link } from 'react-router-dom';
import GenericOffer from './GenericOffer';
import ExpiredOffer from './ExpiredOffer';

const LinkWrapper = ({ link, className, children }) => (
  <Link to={link} className={className}>
    {children}
  </Link>
);

const DivWrapper = ({ className, children }) => <span className={className}>{children}</span>;

//todo: origOffer should just be offer with to transformations inside component when api is ready
const Offer = ({ offer: prodOffer, clickout, size, isExpiredProduct }) => {
  const shopRating = prodOffer.shopRating?.rating ? parseInt(prodOffer.shopRating.rating) : 0;
  const firstMatchingOffer = (offers) =>
    offers.find((offer) => {
      /** Checks if there's a size defined and it's not in the offer, it'll remove it */
      if (size && !offer.size.includes(size)) {
        return false;
      }

      return true;
    });
  //find an offer for requested product size
  const sizeOffer = firstMatchingOffer(prodOffer.offers);
  //selected size offer might have different clickout link, price, etc
  const offer = { ...prodOffer, ...sizeOffer };

  const linkAvailable = !!offer.sdp_path;

  const ShopWrapper = linkAvailable ? LinkWrapper : DivWrapper;

  if (isExpiredProduct)
    return (
      <ExpiredOffer
        ShopWrapper={ShopWrapper}
        shopLink={offer.sdp_path}
        pdpLink={offer.pdp_path}
        shopLogo={offer?.campaignImage}
        shopName={offer.campaign}
        shopRating={shopRating}
        deliveryTime={offer.deliveryTime}
        deliveryCosts={offer.deliveryCosts}
        currency={''}
        price={offer.price}
      />
    );
  // /todo
  return (
    <GenericOffer
      ShopWrapper={ShopWrapper}
      shopLink={offer.sdp_path}
      pdpLink={offer.pdp_path}
      shopLogo={offer?.campaignImage}
      shopName={offer.campaign}
      shopRating={shopRating}
      deliveryTime={offer.deliveryTime}
      deliveryCosts={offer.deliveryCosts}
      currency={''}
      price={offer.price}
      url={offer.url}
      clickout={clickout}
    />
  );
};

export default Offer;
